"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.empty = void 0;

var _Observable = require("./Observable");

var empty = function empty() {
  return (0, _Observable.mkObservable)(function (_observer) {
    return void 6;
  });
};

exports.empty = empty;